/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';

import { EXPERT_PROFILE_STATUS, PER_PAGE } from '../../../utils/constants';
import Pagination from '../../../component/common/Pagination/Pagination';
import PeapProfileDailog from './peapProfileDialog';

import { Api } from '../../../api';
import { cn, errorToast, successToast } from '../../../utils/helper';
import ConfirmPopup from '../../../component/common/modals/ConfirmPopup';
import Select from '../../../component/common/Select';
import RejectExpertPopup from '../../../component/common/modals/RejectExpertPopup';
import Loader from '../../../component/common/Loader';
import { CommonTable } from '../../../component/common/table2/CommonTable';
import moment from 'moment';
import FormSelect from '../../../component/common/FormSelect';
import { pageOptions } from '../../../utils/dropDownConfig';
import CommonPopover from '../../../component/common/popover';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';
import { SpecialistPageData } from '../../../utils/pageContent';

const actionOptions = [
  {
    value: EXPERT_PROFILE_STATUS[2].value,
    label: EXPERT_PROFILE_STATUS[2].name
  },
  {
    value: EXPERT_PROFILE_STATUS[3].value,
    label: EXPERT_PROFILE_STATUS[3].name
  },
  {
    value: EXPERT_PROFILE_STATUS[4].value,
    label: EXPERT_PROFILE_STATUS[4].name
  }
];

function PendingSpecialist(params) {
  const [usersList, setUsersList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedPerPage, setSelectedPerPage] = useState(PER_PAGE[0]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loader, setLoader] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [payload, setPayload] = useState({});
  const [confirmationMessage, setConfirmationMessage] = useState('');
  const [selectedExpertId, setSelectedExpertId] = useState(null);
  const [isLoadingUpdate, setIsLoadingUpdate] = useState(false);
  const navigate = useNavigate();

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const pageData = SpecialistPageData.pendingSpecialistTabData;

  const handleNameClick = (expertId) => {
    // setSelectedExpertId(expertId); // Set the selected expert ID
    // setIsDialogOpen(true); // Open the dialog
    navigate(`/peap-management/profile/${expertId}`);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };
  //const functions
  const handlePagination = (pageNumber, pageSize, userId) => {
    // fetchUsers(pageNumber, pageSize, userId);
    fetchExperts(pageNumber, pageSize);
  };
  //handle dropdown actions in table
  // const handleDropdownChange = (value, rowData) => {
  //   // Handle the change event here
  //   console.log('Selected value:', value);
  //   const expertId = rowData?.id;
  //   const payload = {
  //     expertId,
  //     profileAction: value
  //   };
  //   console.log('Payload:', payload);
  //   switch (value + '') {
  //     case '3':
  //       console.log('Invite to interview');
  //       setOpenConfirmModal(true);
  //       setPayload(payload);
  //       // Api.inviteToInterview(payload).then(handleApiResponse);
  //       break;
  //     case '1':
  //       Api.inviteToInterview(payload).then(handleApiResponse);
  //       console.log('Approve');
  //       break;
  //     case '2':
  //       Api.inviteToInterview(payload).then(handleApiResponse);
  //       console.log('Decline');
  //       break;
  //     case '4':
  //       Api.inviteToInterview();
  //       console.log('Join Interview');

  //     default:
  //       break;
  //   }
  // };

  const handleDropdownChange = (value, rowData) => {
    const expertId = rowData?.id;

    setSelectedExpertId(expertId);
    const payload = {
      id: rowData.expert._id,
      profile_status: value
    };

    // Define the confirmation messages
    const confirmationMessages = {
      2: `Are you sure you want to invite this expert?`,
      3: `Are you sure you want to approve this expert?`,
      4: `Are you sure you want to decline this expert?`,
      5: `Are you sure you want to join the interview?`
    };

    switch (value + '') {
      case '3':
      case '2':
        setConfirmationMessage(confirmationMessages[value]);
        setOpenConfirmModal(true);
        setPayload(payload);
        break;
      case '4':
        setOpenRejectModal(true);
        setPayload(payload);
        break;
      default:
        console.log('Default case');
    }
  };

  const handleSubmitConfirmation = () => {
    setIsLoadingUpdate(true);
    Api.updatePeapExpertProfileStatus(payload)
      .then((response) => {
        setIsLoadingUpdate(false);
        if (response?.data?.meta?.code === 1) {
          successToast(response?.data?.meta?.message);
          setOpenConfirmModal(false);
          fetchExperts(currentPage, selectedPerPage.value);
        } else {
          errorToast(response?.data?.meta?.message);
        }
      })
      .catch((error) => {
        setIsLoadingUpdate(false);
        errorToast(error);
      });
  };

  const handleReject = (reason) => {
    const reqBody = { ...payload, reject_reason: reason };
    setIsLoadingUpdate(true);
    Api.updatePeapExpertProfileStatus(reqBody)
      .then((response) => {
        setIsLoadingUpdate(false);
        if (response?.data?.meta?.code === 1) {
          successToast(response?.data?.meta?.message);
          setOpenRejectModal(false);
          fetchExperts(currentPage, selectedPerPage.value);
        } else {
          errorToast(response?.data?.meta?.message);
        }
      })
      .catch((error) => {
        setIsLoadingUpdate(false);
        errorToast(error);
      });
  };

  // const handleDropdownChange = (value, expertId) => {
  //   let apiCall;
  //   switch (value) {
  //     case '1': // Invite to interview
  //       apiCall = Api.inviteToInterview(expertId);
  //       break;
  //     case '2': // Approve
  //       apiCall = Api.inviteToInterview(expertId);
  //       break;
  //     case '3': // Decline
  //       apiCall = Api.inviteToInterview(expertId);
  //       break;
  //     case '4': // Join Interview
  //       apiCall = Api.inviteToInterview(expertId);
  //       break;
  //     default:
  //       return;
  //   }
  //   apiCall.then(response => {
  //     if (response?.data?.meta?.code === 1) {
  //       console.log(`${value} action performed successfully`);
  //       fetchExperts(currentPage, selectedPerPage);
  //     } else {
  //       console.error(`Failed to perform ${value} action`);
  //     }
  //   });
  // }

  const handleApiResponse = (response) => {
    console.log('hello');

    try {
      if (response?.data?.meta?.code === 1) {
        fetchExperts(currentPage, selectedPerPage.value);
        console.log('selectedPerPage.value', selectedPerPage.value);
      } else {
        const message = response?.data?.meta?.message;
        console.log('🚀 ~ handleApiResponse ~ message:', message);
        // errorToast(message);
      }
    } catch (error) {
      errorToast(error);
    }
  };

  const columns = [
    {
      title: 'Name',
      key: 'name',
      type: 'text3',
      align: 'left',
      longText: true,
      darkText: true
    },

    {
      title: 'Email',
      key: 'email',
      type: 'text',
      align: 'left',
      style: {
        opacity: 'opacity-100',
        align: 'text-left'
      }
    },

    {
      title: 'Date Joined',
      key: 'dateJoined',
      type: 'date',
      align: 'left'
    },
    {
      title: 'Status',
      type: 'status',
      key: 'status',
      style: {
        align: 'text-center',
        textColor: 'text-black',
        opacity: 'opacity-100'
      }
    },

    {
      title: 'Actions',
      type: 'text',
      key: 'action',
      align: 'center',
      style: {
        align: 'flex justify-center'
      }
    }
  ];

  useEffect(() => {
    fetchExperts(currentPage, selectedPerPage.value);
  }, [currentPage, selectedPerPage.value]);

  const fetchExperts = (pageNumber, pageSize) => {
    setLoader(true);
    const status = EXPERT_PROFILE_STATUS.find((item) => item.tag === 'pending_list').value;
    Api.getSpecialistData(pageNumber, pageSize, '', '', status)
      .then((response) => {
        setLoader(false);
        if (response?.data?.meta?.code === 1) {
          setUsersList(response?.data?.data);
          setCurrentPage(pageNumber);
          setTotalCount(response.data.meta.totalRecords);
        } else {
          setUsersList([]);
        }
      })
      .catch((error) => {
        setLoader(false);
        console.error('API call error: ', error);
      });
  };

  const getTags = (status) => {
    return (
      <div
        className={cn(
          'text-sm font-normal text-black py-2 w-[160px] text-center inline-block rounded-full',
          status === 1 && 'bg-black/10',
          status === 2 && 'bg-shoorah-secondary text-white',
          (status === 4 || status === 5 || status === 6 || status === 7 || status === 8) &&
            'bg-[#E35949] text-white'
        )}
      >
        {status === 1
          ? EXPERT_PROFILE_STATUS.find((x) => x.tag === 'pending').name
          : status === 2
          ? 'Invited for interview'
          : status === 4
          ? 'Declined'
          : EXPERT_PROFILE_STATUS.find((x) => x.value === status).name}
      </div>
    );
  };

  const tableData = usersList.map((user) => {
    return {
      name: (
        <span
          onClick={() => handleNameClick(user.id)} // Set expert ID on click
          className="cursor-pointer text-blue-600 hover:underline"
        >
          {user.name}
        </span>
      ),
      email: user.email,
      dateJoined: user.createdAt,
      status:
        user.expert.profile_status === 1
          ? EXPERT_PROFILE_STATUS.find((x) => x.tag === 'pending').name
          : EXPERT_PROFILE_STATUS.find((x) => x.value === user.expert.profile_status).name,
      action: (
        <div className="w-[100px]">
          <Select
            options={actionOptions.filter((option) => option.value !== user.expert.profile_status)}
            onChange={(val) => handleDropdownChange(val, user)}
            placeholder="View"
          />
        </div>
      )
    };
  });

  const column = [
    {
      accessorKey: 'name',
      header: 'Name',
      cell: ({ row }) => {
        return (
          <div className="text-left">
            <div
              onClick={() => handleNameClick(row?.original.id)}
              className="text-sm underline text-shoorah-active font-medium capitalize"
            >
              {row.getValue('name')}
            </div>
          </div>
        );
      },
      enableSorting: false,
      enableHiding: false,
      meta: {
        rowClassName: 'text-base',
        className: 'text-base'
      }
    },
    {
      accessorKey: 'email',
      header: 'Email',
      cell: ({ row }) => (
        <div className="text-sm font-normal whitespace-nowrap">{row.getValue('email')}</div>
      ),
      meta: {
        rowClassName: 'text-sm',
        className: 'text-base'
      }
    },
    {
      accessorKey: 'createdAt',
      header: 'Date Joined',
      cell: ({ row }) => {
        return (
          <div className="text-sm font-normal text-black/50 whitespace-nowrap">
            {row.getValue('createdAt')
              ? moment(row.getValue('createdAt')).format('MMM D, YYYY')
              : '-'}
          </div>
        );
      },
      meta: {
        rowClassName: 'text-sm',
        className: 'text-base'
      }
    },
    // {
    //   accessorKey: 'createdAt',
    //   header: 'Date Joined',
    //   cell: ({ row }) => {
    //     return row.getValue('createdAt')
    //       ? moment(row.getValue('createdAt')).format('MMM D, YYYY')
    //       : '-';
    //   }
    // },
    // {
    //   accessorKey: 'legalsent',
    //   header: 'Legals sent',
    //   cell: ({ row }) => {
    //     return (
    //       <div className="flex w-full justify-center">
    //         <CheckBox
    //           // id={option.value}
    //           checked={row.original.expert.legalsSent ? row.original.expert.legalsSent : false}
    //           className={cn('border-black/20')}
    //           // onClick={() => handleChange(option)}
    //         />
    //       </div>
    //     );
    //   },
    //   meta: {
    //     rowClassName: 'text-center',
    //     className: 'text-center'
    //   }
    // },
    // {
    //   accessorKey: 'legalaccepted',
    //   header: 'Legals accepted',
    //   cell: ({ row }) => {
    //     return (
    //       <div className="flex w-full justify-center">
    //         <CheckBox
    //           // id={option.value}
    //           checked={
    //             row.original.expert.LegalsAccepted ? row.original.expert.LegalsAccepted : false
    //           }
    //           className={cn('border-black/20')}
    //           // onClick={() => handleChange(option)}
    //         />
    //       </div>
    //     );
    //   },
    //   meta: {
    //     rowClassName: 'text-center',
    //     className: 'text-center'
    //   }
    // },
    {
      accessorKey: 'status',
      header: <div className={`${usersList.length > 0 ? 'text-center' : ''}`}>Status</div>,
      cell: ({ row }) => {
        const userId = row.original.user_id;
        return (
          <div className="relative text-center">{getTags(row.original.expert.profile_status)}</div>
        );
      },
      meta: {
        rowClassName: 'text-sm',
        className: 'text-base'
      }
    },
    {
      accessorKey: 'action',
      header: 'Action',
      cell: ({ row }) => {
        const userId = row.original.user_id;

        return (
          <div className="w-[100px]">
            {/* <Select
              options={actionOptions.filter(
                (option) => option.value !== row.original.expert.profile_status
              )}
              onChange={(val) => handleDropdownChange(val, row.original)}
              placeholder="View"
            /> */}
            <CommonPopover
              label={
                <>
                  <span>{pageData.tableHeaderText.selectText}</span>
                  <ChevronDownIcon className="w-5 h-5" />
                </>
              }
              className={`w-[120px] gap-3 text-sm py-2 rounded-[5px] text-black dark:text-white border-shoorah-gray10`}
              contentClassName={`w-[200px] rounded-2xl px-0 py-[10px]`}
            >
              <div className={`text-base`}>
                {actionOptions
                  .filter((option) => option.value !== row.original.expert.profile_status)
                  .map((option) => (
                    <div className=" px-6 py-3 hover:text-shoorah-secondary hover:bg-[#E5EAF966]">
                      <button
                        onClick={() => handleDropdownChange(option.value, row.original)}
                        class="outline-none text-base"
                      >
                        {option.label}
                      </button>
                    </div>
                  ))}
              </div>
            </CommonPopover>
          </div>
        );
      },
      meta: {
        rowClassName: 'text-base',
        className: 'text-base'
      }
    }
  ];

  return (
    <div>
      <div className="mt-5">
        <div className="flex justify-center"></div>
        {loader && <Loader />}
        <div className="p-6 bg-white rounded-2xl dark:border-none border-[1.5px] dark:bg-shoorah-darkBgTabColor border-shoorah-borderGray">
          <div className="flex flex-col text-shoorah-lightBlack dark:text-shoorah-darkBg">
            <div className="text-base font-medium">Pending Specialist</div>
            <div className="text-sm font-normal">
              A quick snapshot of all specialists who are waiting to join Shoorah.
            </div>
          </div>
          <div className="mt-5">
            <FormSelect
              options={pageOptions}
              name={'recordsPerPage'}
              value={selectedPerPage.value}
              className="bg-transparent w-[200px] text-sm leading-6"
              onChange={(_, value) => {
                const opt = pageOptions.find((x) => x.value === value);
                setSelectedPerPage(opt);
              }}
            />
          </div>
          <div className="mt-5">
            <CommonTable columns={column} data={usersList} />
            {isDialogOpen && (
              <PeapProfileDailog
                onClose={handleCloseDialog}
                open={isDialogOpen}
                expertId={selectedExpertId}
                refetchList={() => fetchExperts(currentPage, selectedPerPage.value)}
              />
            )}
          </div>
          <div></div>
        </div>
      </div>
      <div>
        {/* {usersList?.length >= 10 ? ( */}
        {totalCount > selectedPerPage?.value ? (
          <Pagination
            currentPage={currentPage}
            totalCount={totalCount}
            pageSize={selectedPerPage?.value}
            onPageChange={(page) => handlePagination(page, selectedPerPage?.value, '')}
          />
        ) : (
          <span />
        )}
      </div>
      {openConfirmModal && (
        <ConfirmPopup
          open={openConfirmModal}
          setOpen={setOpenConfirmModal}
          message={confirmationMessage}
          setAccepted={handleSubmitConfirmation}
          handleNo={() => {
            setOpenConfirmModal(false);
          }}
          isLoading={isLoadingUpdate}
        />
      )}
      <RejectExpertPopup
        open={openRejectModal}
        onClose={() => setOpenRejectModal(false)}
        onSubmit={handleReject}
        isLoading={isLoadingUpdate}
      />
    </div>
  );
}

export default PendingSpecialist;
